<template>
  <div class="row justify-content-center align-items-center vh-100">
    <div class="col-12 col-md-10 col-lg-8">
      <div id="pnlActivation" class="card bg-light">
        <div class="card-body px-0">
          <form-wizard title="Please register your application" subtitle="" ref="wizard">
            <template #step="props">
              <wizard-step :tab="props.tab"
                           :transition="props.transition"
                           :key="props.tab.title"
                           :index="props.index">
              </wizard-step>
            </template>
            <tab-content title="Serial Number" :before-change="checkSerialRegistration">
              <div id="pnlError">
                <p class="text-danger h4 text-center">{{ errorMessage }}</p>
              </div>
              <label for="txtSerialNumber">Insert your serial number:</label>
              <div class="input-group my-3">
                <input id="txtSerialNumber" type="text" class="form-control" placeholder="Serial Number" aria-label="Insert your serial number:"
                    aria-describedby="basic-addon2" maxlength="36" v-model="serialNumber" @blur="serialNumber = serialNumber.toLowerCase()">
              </div>
            </tab-content>

            <tab-content title="User Info" :before-change="registerActivation">
              <div v-if="registered">
                <label for="input-fullName-registered">This application is already registered to the name below:</label>
                <div class="input-group my-3">
                  <b-form-input id="input-fullName-registered" v-model="fullName" readonly />
                </div>
              </div>

              <div v-if="!registered">
                <b-form-group id="input-group-fullName" label="Full name:" label-for="input-fullName">
                  <b-form-input
                      id="input-fullName"
                      v-model="fullName"
                      placeholder="Full Name"
                      maxlength="50"
                      required
                  />
                </b-form-group>
                <b-form-group  id="input-group-email" label="Email:"  label-for="input-email">
                  <b-form-input
                      id="input-email"
                      v-model="email"
                      type="email"
                      placeholder="Email"
                      required/>
                </b-form-group>
                <b-form-group id="input-group-country" label="Country:" label-for="input-country">
                  <b-form-select
                      id="input-country"
                      v-model="country"
                      class="mb-2 mr-sm-2 mb-sm-0"
                      :options="availableCountrySelections()"
                      :value="null"
                  />
                </b-form-group>
                <b-form-group  id="input-group-address" label="Address:" label-for="input-address">
                  <b-form-input
                      id="input-address"
                      v-model="address"
                      placeholder="Address"
                      maxlength="50"
                      required/>
                </b-form-group>
                <b-form-group  id="input-group-telephone" label="Telephone:" label-for="input-telephone">
                  <b-form-input
                      id="input-telephone"
                      v-model="telephone"
                      placeholder="Telephone"
                      maxlength="30"
                      required/>
                </b-form-group>
              </div>
            </tab-content>

            <tab-content title="Verification" :before-change="completeActivation">
              <div class="h1 text-center">
                Activation Complete!
              </div>
            </tab-content>
          </form-wizard>
        </div>
        <p v-if="isNetworkOffline || showNetworkBackOnlineMessage"
           class="text-center"
           :class="[isNetworkOffline ? 'text-danger' : 'text-success']">
          {{ isNetworkOffline ? $t("telestia.network.offline_warning") : $t("telestia.network.back_online_message") }}
        </p>
      </div>
    </div>

    <about ref="about" />
    <b-button id="aboutButton" variant="primary" @click="showAbout">
      <font-awesome-icon size="lg" :icon="['fas','question']"/><br>
    </b-button>
  </div>
</template>

<script>

import activation from "../../shared/helpers/activation";
import { hardwareInfo } from "../../shared/utils/hardware";
import { version } from '../../../package.json';
import About from '../shared/About.vue';

export default {
  name: 'activation-wizard',
  
  components: {
    About
  },

  data: function () {
    return {
      showNetworkBackOnlineMessage: false,
      loading: false,
      errorMessage: '',

      // license details
      computerId: null,
      serialNumber: null, // f8eaad55-e015-40c1-9d77-8ea385f6e6bc
      licenseId: null,
      activationId: null,

      // registration details
      fullName:   null,
      email:      null,
      country:    null,
      address:    null,
      telephone:  null,

      registered: false,

      countries: {'AF': 'Afghanistan', 'AX': '\u00c5land Islands', 'AL': 'Albania', 'DZ': 'Algeria', 'AS': 'American Samoa', 'AD': 'Andorra', 'AO': 'Angola', 'AI': 'Anguilla', 'AQ': 'Antarctica', 'AG': 'Antigua & Barbuda', 'AR': 'Argentina', 'AM': 'Armenia', 'AW': 'Aruba', 'AC': 'Ascension Island', 'AU': 'Australia', 'AT': 'Austria', 'AZ': 'Azerbaijan', 'BS': 'Bahamas', 'BH': 'Bahrain', 'BD': 'Bangladesh', 'BB': 'Barbados', 'BY': 'Belarus', 'BE': 'Belgium', 'BZ': 'Belize', 'BJ': 'Benin', 'BM': 'Bermuda', 'BT': 'Bhutan', 'BO': 'Bolivia', 'BA': 'Bosnia & Herzegovina', 'BW': 'Botswana', 'BR': 'Brazil', 'IO': 'British Indian Ocean Territory', 'VG': 'British Virgin Islands', 'BN': 'Brunei', 'BG': 'Bulgaria', 'BF': 'Burkina Faso', 'BI': 'Burundi', 'KH': 'Cambodia', 'CM': 'Cameroon', 'CA': 'Canada', 'IC': 'Canary Islands', 'CV': 'Cape Verde', 'BQ': 'Caribbean Netherlands', 'KY': 'Cayman Islands', 'CF': 'Central African Republic', 'EA': 'Ceuta & Melilla', 'TD': 'Chad', 'CL': 'Chile', 'CN': 'China', 'CX': 'Christmas Island', 'CC': 'Cocos (Keeling) Islands', 'CO': 'Colombia', 'KM': 'Comoros', 'CG': 'Congo - Brazzaville', 'CD': 'Congo - Kinshasa', 'CK': 'Cook Islands', 'CR': 'Costa Rica', 'CI': 'C\u00f4te d\u2019Ivoire', 'HR': 'Croatia', 'CU': 'Cuba', 'CW': 'Cura\u00e7ao', 'CY': 'Cyprus', 'CZ': 'Czechia', 'DK': 'Denmark', 'DG': 'Diego Garcia', 'DJ': 'Djibouti', 'DM': 'Dominica', 'DO': 'Dominican Republic', 'EC': 'Ecuador', 'EG': 'Egypt', 'SV': 'El Salvador', 'GQ': 'Equatorial Guinea', 'ER': 'Eritrea', 'EE': 'Estonia', 'SZ': 'Eswatini', 'ET': 'Ethiopia', 'FK': 'Falkland Islands', 'FO': 'Faroe Islands', 'FJ': 'Fiji', 'FI': 'Finland', 'FR': 'France', 'GF': 'French Guiana', 'PF': 'French Polynesia', 'TF': 'French Southern Territories', 'GA': 'Gabon', 'GM': 'Gambia', 'GE': 'Georgia', 'DE': 'Germany', 'GH': 'Ghana', 'GI': 'Gibraltar', 'GR': 'Greece', 'GL': 'Greenland', 'GD': 'Grenada', 'GP': 'Guadeloupe', 'GU': 'Guam', 'GT': 'Guatemala', 'GG': 'Guernsey', 'GN': 'Guinea', 'GW': 'Guinea-Bissau', 'GY': 'Guyana', 'HT': 'Haiti', 'HN': 'Honduras', 'HK': 'Hong Kong SAR China', 'HU': 'Hungary', 'IS': 'Iceland', 'IN': 'India', 'ID': 'Indonesia', 'IR': 'Iran', 'IQ': 'Iraq', 'IE': 'Ireland', 'IM': 'Isle of Man', 'IL': 'Israel', 'IT': 'Italy', 'JM': 'Jamaica', 'JP': 'Japan', 'JE': 'Jersey', 'JO': 'Jordan', 'KZ': 'Kazakhstan', 'KE': 'Kenya', 'KI': 'Kiribati', 'XK': 'Kosovo', 'KW': 'Kuwait', 'KG': 'Kyrgyzstan', 'LA': 'Laos', 'LV': 'Latvia', 'LB': 'Lebanon', 'LS': 'Lesotho', 'LR': 'Liberia', 'LY': 'Libya', 'LI': 'Liechtenstein', 'LT': 'Lithuania', 'LU': 'Luxembourg', 'MO': 'Macao SAR China', 'MG': 'Madagascar', 'MW': 'Malawi', 'MY': 'Malaysia', 'MV': 'Maldives', 'ML': 'Mali', 'MT': 'Malta', 'MH': 'Marshall Islands', 'MQ': 'Martinique', 'MR': 'Mauritania', 'MU': 'Mauritius', 'YT': 'Mayotte', 'MX': 'Mexico', 'FM': 'Micronesia', 'MD': 'Moldova', 'MC': 'Monaco', 'MN': 'Mongolia', 'ME': 'Montenegro', 'MS': 'Montserrat', 'MA': 'Morocco', 'MZ': 'Mozambique', 'MM': 'Myanmar (Burma)', 'NA': 'Namibia', 'NR': 'Nauru', 'NP': 'Nepal', 'NL': 'Netherlands', 'NC': 'New Caledonia', 'NZ': 'New Zealand', 'NI': 'Nicaragua', 'NE': 'Niger', 'NG': 'Nigeria', 'NU': 'Niue', 'NF': 'Norfolk Island', 'KP': 'North Korea', 'MK': 'North Macedonia', 'MP': 'Northern Mariana Islands', 'NO': 'Norway', 'OM': 'Oman', 'PK': 'Pakistan', 'PW': 'Palau', 'PS': 'Palestinian Territories', 'PA': 'Panama', 'PG': 'Papua New Guinea', 'PY': 'Paraguay', 'PE': 'Peru', 'PH': 'Philippines', 'PN': 'Pitcairn Islands', 'PL': 'Poland', 'PT': 'Portugal', 'XA': 'Pseudo-Accents', 'XB': 'Pseudo-Bidi', 'PR': 'Puerto Rico', 'QA': 'Qatar', 'RE': 'R\u00e9union', 'RO': 'Romania', 'RU': 'Russia', 'RW': 'Rwanda', 'WS': 'Samoa', 'SM': 'San Marino', 'ST': 'S\u00e3o Tom\u00e9 & Pr\u00edncipe', 'SA': 'Saudi Arabia', 'SN': 'Senegal', 'RS': 'Serbia', 'SC': 'Seychelles', 'SL': 'Sierra Leone', 'SG': 'Singapore', 'SX': 'Sint Maarten', 'SK': 'Slovakia', 'SI': 'Slovenia', 'SB': 'Solomon Islands', 'SO': 'Somalia', 'ZA': 'South Africa', 'GS': 'South Georgia & South Sandwich Islands', 'KR': 'South Korea', 'SS': 'South Sudan', 'ES': 'Spain', 'LK': 'Sri Lanka', 'BL': 'St. Barth\u00e9lemy', 'SH': 'St. Helena', 'KN': 'St. Kitts & Nevis', 'LC': 'St. Lucia', 'MF': 'St. Martin', 'PM': 'St. Pierre & Miquelon', 'VC': 'St. Vincent & Grenadines', 'SD': 'Sudan', 'SR': 'Suriname', 'SJ': 'Svalbard & Jan Mayen', 'SE': 'Sweden', 'CH': 'Switzerland', 'SY': 'Syria', 'TW': 'Taiwan', 'TJ': 'Tajikistan', 'TZ': 'Tanzania', 'TH': 'Thailand', 'TL': 'Timor-Leste', 'TG': 'Togo', 'TK': 'Tokelau', 'TO': 'Tonga', 'TT': 'Trinidad & Tobago', 'TA': 'Tristan da Cunha', 'TN': 'Tunisia', 'TR': 'Turkey', 'TM': 'Turkmenistan', 'TC': 'Turks & Caicos Islands', 'TV': 'Tuvalu', 'UM': 'U.S. Outlying Islands', 'VI': 'U.S. Virgin Islands', 'UG': 'Uganda', 'UA': 'Ukraine', 'AE': 'United Arab Emirates', 'GB': 'United Kingdom', 'US': 'United States', 'UY': 'Uruguay', 'UZ': 'Uzbekistan', 'VU': 'Vanuatu', 'VA': 'Vatican City', 'VE': 'Venezuela', 'VN': 'Vietnam', 'WF': 'Wallis & Futuna', 'EH': 'Western Sahara', 'YE': 'Yemen', 'ZM': 'Zambia', 'ZW': 'Zimbabwe'}
    }
  },

  computed: {
    isNetworkOffline() { return this.$store.getters['network/isNetworkOffline'] },
  },

  watch: {
    isNetworkOffline(previousState, nextState) {
      if (!previousState && nextState) {
        this.showNetworkBackOnlineMessage = true;
        setTimeout(() => this.showNetworkBackOnlineMessage = false, 3000);
      }
    }
  },

  mounted: async function() {
    await this.init()
    hardwareInfo();
    await this.checkActivation()
  },

  methods: {
    init: async function () {
      this.serialNumber = this.$store.getters.getSerialNumber
      this.computerId   = this.$store.getters.getComputerId
      this.licenseId    = this.$store.getters.getLicenseId
      this.activationId = this.$store.getters.getActivation
    },
    
    showAbout() {
      this.$refs.about.show();
    },

    showMessage: function(message) {
      this.errorMessage = message;
      this.$swal({
        title: 'Message',
        text: message,
        icon: 'error',
        timer: 5000,
        button: true,
      });
    },

    validateEmail(email) {
      if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        this.showSwalMessage('Error', 'Please enter a valid email address.', 'error', 10000, true, null, true);
        return false;
      }
      return true;
    },

    availableCountrySelections: function () {
      let countrySelections = [{ text: 'Choose...', value: null }]
      Object.entries(this.countries).forEach(([key, value]) => {
        countrySelections.push({ text: value, value: key })
      });
      return countrySelections
    },

    // Checks whether the provided serial number is valid. If the method returns true, you get to the next wizard tab,
    // If false, there was an error, you remain on the same tab
    checkSerialRegistration: async function () {
      if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(this.serialNumber)) {
        this.showSwalMessage('Wrong serial number', 'Invalid format, please check for a possible typo', 'error', 20000, true)
        return false
      }

      let payload = {
        serialNumber: this.serialNumber
      }
      return await this.$axios
          .get(`/user/check_registration`, { params: payload })
          .then((response) => {
            if (response.data !== null && response.data.status === 'ok') {
              this.fullName = response.data.body
              this.registered = this.fullName !== '';
              this.$store.commit("setSerialNumber", this.serialNumber)

              return true
            } else {
              this.showSwalMessage('Wrong serial number', 'Check for a typo', 'error', 20000, true)
              return false
            }
          })
          .catch(error => {
            this.showSwalMessage('', 'Something went wrong, please check your internet connection', 'error', 20000, true, error)
            return false
          })
    },

    checkLicenseRegistration: async function () {
      const payload = {
        activationId: this.activationId,
        version: version
      }

      return await this.$axios
          .post(`/user/check_license`, { params: payload })
          .then((response) => {
            if (response.data !== null && response.status === 200) {
              console.log(response.data)
            } else {
              this.showSwalMessage('Wrong serial number', 'Check for a typo', 'error', 20000, true)
            }
          })
          .catch(error => {
            this.showSwalMessage('', 'Something went wrong, please check your internet connection', 'error', 20000, true, error)
            return false
          })
    },

    registerActivation: async function () {
      try {
        if (!this.registered) {
          if (!this.fullName || !this.address || !this.telephone || !this.country || !this.email) {
            this.showSwalMessage('Error', 'Please complete your registration by filling in all form fields.', 'error', 10000, true, null, true);
            return true;
          }
          if (!this.validateEmail(this.email)) return true;
        }

        const hardware = await hardwareInfo();
        const computerId = await activation.calculateComputerId()
        const licenseId = activation.calculateLicenceId(computerId, this.serialNumber)
        const authenticationHash = activation.calculateActivationHashParam(this.serialNumber, computerId, licenseId)

        let payload = {
          hardware,
          computerId,
          licenseId,
          hash: authenticationHash,
          serialNumber: this.serialNumber,
          registered: this.registered ? 1 : 0,
          form: {}
        }
        if (!this.registered) {
          payload.form = {
            address: this.address,
            country: this.countries[this.country] || this.country,
            email: this.email,
            fullname: this.fullName,
            telephone: this.telephone
          }
        }
        return await this.$axios
            .post(`/user/check_activation`, { params: payload })
            .then((response) => {
              if (response.data !== null && response.status === 200) {
                // console.warn('HTTP BODY', response.data)
                const activationId = response.data.body.split(/\r?\n/, 1)[0]
                switch (activationId) {
                  case 'Errornotfound':
                    this.showSwalMessage('Wrong serial number', 'The serial number you entered is wrong.', 'error', 20000, true, null, true);
                    return false;
                  case 'Error100':
                    this.showSwalMessage('Error', 'ERROR: Authentication failed.', 'error', 20000, true, null, true);
                    return false;
                  case 'Error300':
                    this.showSwalMessage('Unavailable license', 'This serial number has no availble licenses.', 'error', 20000, true, null, true);
                    return false;
                  default:
                    if (activationId != activation.calcActivation(this.serialNumber, computerId, licenseId)) {
                      this.showSwalMessage('Wrong serial number', 'The serial number you entered is not valid for this application.', 'error', 20000, true, null, true);
                      return false;
                    }
                    this.$store.dispatch('setLicenseData', {
                      computerId: computerId,
                      licenseId: licenseId,
                      activationId: activationId,
                      fullName: this.fullName,
                      lastCheck: Date.now(),
                    });
                    return true;
                }
              } else {
                this.showSwalMessage('', 'ERROR 6: Error contacting the license server. Try again', 'error', 20000, true)
                return false
              }
            })
            .catch(error => {
              this.showSwalMessage('', 'Something went wrong, please check your internet connection', 'error', 20000, true, error)
              return false
            })
      } catch (e) {
        console.log(e);
      }
    },

    checkActivation: async function () {
      try {
        const isAppActivated = await this.$store.dispatch('checkAppActivation');
        this.$store.commit("setActivated", isAppActivated);
        if (isAppActivated) { 
          await this.$router.replace({ name: 'App:Main' });
        } else {
          await this.$store.dispatch('clearLicense');
          this.$store.dispatch('user/clearSession', {});
          this.$router.push({ path: '/authorization' });
        }
      } catch (e) {
        console.log(e);
      }
    },

    completeActivation: function () {
      this.$store.commit("setActivated", true)
      this.$router.replace({ name: 'App:Main' })
      return true
    },

    showSwalMessage: function(title, text, icon, timer, button, error = null, back = false) {
      this.$swal({ title, text, icon, timer, error, button });
      if (back) this.$refs.wizard.prevTab();
    }
  }
}
</script>


<style scoped>
#aboutButton {
  position: absolute;
  bottom: 20px;
  right: 20px;
  width: auto;
}
</style>